import ScheduleTab from '@/schedule/ScheduleTab';

// The Schedule has its own page (sidebar: Schedule). Every role lands on the
// same schedule view; claim / unclaim sit on the event cards. The admin area
// opens as a separate page from the Admin button inside it.
export default function SchedulePage() {
  return (
    <div data-testid="schedule-page">
      <ScheduleTab />
    </div>
  );
}
